import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';

type MuiLinearProgress = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiLinearProgress'];
  defaultProps?: ComponentsProps['MuiLinearProgress'];
  variants?: ComponentsVariants['MuiLinearProgress'];
};

export const MuiLinearProgress: MuiLinearProgress = {
  styleOverrides: {
    root: {
      borderRadius: 5,
    },
    bar: {
      borderRadius: 5,
    },
  },
};
